export default __webpack_public_path__ + "static/media/2025.6f82315d.png";